<template>
  <div class="activity-v2-sidebar position-fixed width-tab-title-sidebar" :class="sidebarWrapperClass">
    <button
      id="btn-close-sidebar"
      class="btn-close-sidebar position-absolute p-0 border-0 bg-white"
      @click="toggleSidebar('halaman_belajar_exit_button_click')"
    ></button>
    <b-tabs-kariermu
      :active-tab="activeTabIndex"
      :tabs="tabsDefinitions"
      content-class="p-3 k-sidebar-tabs"
      nav-wrapper-class="sidebar-nav"
      @activate-tab="onActivateTab"
    >
      <template #tab-activity>
        Aktivitas
      </template>
      <template #tab-0>
        <tab-activity class="k-tab-activity" />
        <tab-activity-shortcuts
          v-if="program.is_asesor && report.show_certificate"
         :class="shortcutClass"
         @viewCertificate="switchToTab('assessment')"
        />
      </template>
      <template #tab-announcement>

      </template>
      <template #tab-1>
      </template>
      <template #tab-assessment>
        Penilaian
      </template>
      <template #tab-2>
        <report-sidebar :is-mobile="isMobile" />
        <report v-if="isMobile" />
      </template>
    </b-tabs-kariermu>
  </div>
</template>
<script>
import { defineAsyncComponent } from 'vue'
import { mapState } from 'vuex'
import { isMobile, isIOS } from 'mobile-device-detect'
import TabActivity from '@/components/activityV2/Sidebar/Tabs/TabActivity'
import activityV2GeneralMixin from '@/mixins/activityV2/general'
import activityV2SidebarMixin from '@/mixins/activityV2SidebarMixin'
import ReportSidebar from '@/components/activityV2/Report/ReportSidebar.vue'

const Report = defineAsyncComponent(() => import('@/components/activityV2/Report'))
const TabActivityShortcuts = defineAsyncComponent(() => import('@/components/activityV2/Sidebar/Tabs/TabActivity/Shortcuts'))

export default {
  components: {
    TabActivity,
    ReportSidebar,
    Report,
    TabActivityShortcuts
  },
  mixins: [activityV2GeneralMixin, activityV2SidebarMixin],
  data () {
    return {
      isVisible: false,
      isMobile,
      isIOS,
      isShortcutSticky: false,
      scrollPos: 0
    }
  },
  computed: {
    ...mapState('activityV2', ['report']),
    userInfo () {
      return this.$store.state.user.userInfo
    },
    sidebarWrapperClass () {
      return {
        'sidebar-mobile-ios': this.isIOS
      }
    },
    shortcutClass () {
      return this.isShortcutSticky ? 'position-sticky' : ''
    },
    tabsDefinitions () {
      return [
        {
          titleHtml: 'tab-activity',
          titleClass: '',
          onClick: () => this.logEventAnalytic('AKTIVITAS_CLICK', undefined, 'activity')
        },
        {
          titleHtml: 'tab-announcement',
          titleClass: 'd-none',
          onClick: () => this.logEventAnalytic('pengumuman_click')()
        },
        {
          titleHtml: 'tab-assessment',
          titleClass: this.tabGroupDiscussionClass,
          onClick: () => this.logEventAnalytic('PENILAIAN_CLICK', undefined, 'assessment')
        }
      ]
    }
  },
  methods: {
    toggleNotificationDot () {
      this.isVisible = !this.isVisible
    },
    handleStickyShortcut () {
      const tabActivity = document.querySelector('.k-tab-activity')
      if ((tabActivity.getBoundingClientRect()).top > this.scrollPos) {
        this.isShortcutSticky = true
      } else {
        this.isShortcutSticky = false
      }
      this.scrollPos = (tabActivity.getBoundingClientRect()).top
    },
    onActivateTab (newTab) {
      this.activeTabIndex = newTab
    }
  },
  mounted () {
    if (!this.isMobile) {
      this.toggleSidebar()
    }
    const sidebarTabsContainer = document.querySelector('.k-sidebar-tabs')
    sidebarTabsContainer.addEventListener('scroll', this.handleStickyShortcut)
  },
  beforeUnmount () {
    const sidebarTabsContainer = document.querySelector('.k-sidebar-tabs')
    sidebarTabsContainer.removeEventListener('scroll', this.handleStickyShortcut)
  },
  watch: {
    sidebarActiveTab (value) {
      if (value !== 2) {
        this.isShortcutSticky = false
      }
    }
  }
}
</script>
<style scoped>
.notification-dot {
  height: 8px;
  width: 8px;
  background-color: var(--color-crimson-500);
  margin: 4px 0;
}

.width-tab-title-sidebar >>> .nav-tabs .nav-link {
  width: 156px;
  text-align: center;
}

.width-tab-title-sidebar >>> .nav {
  display: inline-flex;
}

@media (max-width: 355px) {
  .width-tab-title-sidebar >>> .nav-tabs .nav-link {
    width: 150px;
  }
}

@media (max-width: 345px) {
  .width-tab-title-sidebar >>> .nav-tabs .nav-link {
    width: 145px;
  }
}

@media (max-width: 335px) {
  .width-tab-title-sidebar >>> .nav-tabs .nav-link {
    width: 140px;
  }
}

>>> .nav-tabs {
  border-bottom: none;
  padding: 8px;
}

>>> .nav-tabs .nav-link {
  border: none;
  text-align: center;
  padding: 8px;
  color: var(--color-ui-text-secondary-2);
  font-family: var(--ff-primary);
  font-weight: 600;
  font-size: 16px;
}

@media (max-width: 359px) {
  >>> .nav-tabs .nav-link {
    font-size: 14px;
  }
}

>>> .nav-tabs .active {
  position: relative;
  color: var(--color-royal-navy-500);
}

>>> .nav-tabs .active::before {
  content: "";
  position: absolute;
  display: block;
  width: calc(100% - 16px);
  bottom: 0;
  height: 4px;
  background-color: var(--color-royal-navy-500);
  border-radius: 5px;
}

.activity-v2-sidebar {
  width: 100%;
  max-width: 100%;
  right: -100%;
  top: 0;
  height: 100%;
  background-color: var(--color-ui-element-white-3);
  -webkit-transition: right 0.3s ease-in-out;
  -o-transition: right 0.3s ease-in-out;
  transition: right 0.3s ease-in-out;
  z-index: 12;
}

@media (min-width: 500px) {
  .activity-v2-sidebar {
    max-width: 378px;
  }
}

.activity-v2-sidebar >>> .tab-content {
  max-height: 100vh;
  overflow: auto;
  padding-bottom: 60px!important;
}

.sidebar-mobile-ios >>> .tab-content {
  padding-bottom: 170px!important;
}

.btn-close-sidebar {
  right: 8px;
  top: 15px;
  z-index: 10;
  width: 24px;
  height: 24px;
}

.btn-close-sidebar::before {
  content: '';
  position: absolute;
  background-image: url('https://cdn.karier.mu/assets/icon/icon-x-mark-rounded.svg');
  background-size: 16px 16px;
  filter: var(--filter-color-netural-700);
  background-repeat: no-repeat;
  background-position: center;
  height: 16px;
  width: 16px;
  top: 4px;
  right: 4px;
}

.btn-close-sidebar:active,
.btn-close-sidebar:focus {
  outline: none;
}

>>> .topic-title {
  line-height: 24px;
}

>>> .topic-addon-list::before {
  position: absolute;
  content: '';
  background-color: var(--color-eucalyptus-500);
  width: 6px;
  height: calc(100% - 32px);
  border-radius: 10px;
  top: 0;
  left: 0;
}

>>> .toggle-description-icon {
  filter: var(--filter-color-royal-navy-500)
}

>>> .meta-info {
  line-height: 17px;
}

>>> .btn-enroll-addon {
  min-width: 132px;
}
</style>
